{
    "title": "Verification code Validation",
    "otpValForChangePswd": {
        "label": "Enter OTP"       
    },
    "validateMsg":{
        "otp":"Please enter valid Verification Code",
        "numberOnly":"Number Only"
    },
    
    "placeHolder":{
        "otp":"Enter OTP"
    },
    "resend":{
        "label":"Resend?"
    },
    "backBtn":{
        "label": "Back"
    },
    "submitBtn":{
        "label": "Submit"
    }

}